export default class VisibilityService {
    private static readonly vueModalSelector: string = 'fl-modal-container';
    private static getElement(): HTMLElement {
        return document.getElementById(VisibilityService.vueModalSelector);
    }

    public static show(): void {
        this.getElement().style.visibility = 'visible';
        this.getElement().style.opacity = '1';
        this.getElement().style.maxHeight = 'none';
    }

    public static hide(): void {
        this.getElement().style.visibility = 'hidden';
        this.getElement().style.opacity = '0';
        this.getElement().style.maxHeight = '0px';
    }
}
